<div class="modal-body">
  <p><Label [innerHTML]="dialogData.data.para"> </Label></p>  
  <hr *ngIf="dialogData.data.showFooterLine"/>
  
      <button *ngIf="dialogData.data.showFooterBtn && !dialogData.data.yesBtnHide"
      class="btn btn-primary"
      (click)="yesPopup()"
      >
      {{ dialogData.data.yesBtnLabel }}
      </button>

      <button *ngIf="dialogData.data.showFooterBtn && !dialogData.data.noBtnHide"
        class="btn btn-primary"
        (click)="noPopup()"
      >
        {{ dialogData.data.noBtnLabel }}
      </button>

  
  </div>
  